import React from "react";
import "./Lists.scss";

const Lists = () => {
  return (
    <div className="primary lists">
      <div className="title">Wecome to Lists Page</div>
    </div>
  );
};

export default Lists;
